export default class ContactRequest {
    public Name: string = "";
    public EMail: string = "";
    public Phone: string = "";
    public Requirement: string = "";
    public Message: string = "";
    public Captcha: string = "";
}